import { render, staticRenderFns } from "./AssignInterpreterModal.vue?vue&type=template&id=6a7694b0"
import script from "./AssignInterpreterModal.vue?vue&type=script&lang=ts"
export * from "./AssignInterpreterModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports